import React, { useRef, useState, useEffect } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import classNames from 'classnames';

import { useIntl } from '../../../../util/reactIntl';
import { isMainSearchTypeKeywords } from '../../../../util/search';

import { Form, LocationAutocompleteInput } from '../../../../components';

import IconSearchDesktop from './IconSearchDesktop';
import { Button, Input, Select, Space } from 'antd';
import {
  SearchOutlined,
} from '@ant-design/icons';
import css from './TopbarSearchForm.module.css';
import { createResourceLocatorString } from '../../../../util/routes';
import { useHistory } from 'react-router-dom';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { userTypeOf } from '../../../../util/userType';
import { teamRoleOf } from '../../../../util/teamRole';

const identity = v => v;

const KeywordSearchField = props => {
  const { keywordSearchWrapperClasses, iconClass, intl, isMobile = false, inputRef, onSubmit, currentUser, profileListing } = props;

  let defaultCategory = null;
  let defaultKeyword = '';
  const [keyword, setKeyword] = useState(defaultKeyword);
  const [listingType, setListingType] = useState(null);

  
  
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const currentUserType = userTypeOf(currentUser);
  const agencyType = currentUser?.attributes?.profile?.publicData?.agencyProfile?.agencyType || profileListing?.attributes?.publicData?.agencyProfile?.agencyType || null;

  if (typeof window !== 'undefined') {
    const { pathname, search } = window.location;
    const queryParams = new URLSearchParams(search);

    // set category based on pathname or pub_listingType
    if (pathname === '/s' && currentUserType === 'candidate') {
      defaultCategory = 'work';
    } else if (pathname === '/s') {
      defaultCategory = 'work';
    }

    const localListingType = queryParams.get('pub_listingType');
    switch (localListingType) {
      case 'candidate':
        defaultCategory = 'talent';
        break;
      case 'agency':
        defaultCategory = 'partners';
        break;
      case 'job_listing':
        defaultCategory = 'work';
        break;
      case 'rfp_listing':
        defaultCategory = 'rfps';
        break;
      default:
        break;
    }

    // get keyword if exists
    const keyword = queryParams.get('keywords');
    if (keyword) {
      defaultKeyword = keyword;
      
    }
  }

  // Update listingType state when defaultCategory changes
  useEffect(() => {
    if (defaultCategory) {
      const listingTypeFromCategory = defaultCategory === 'work' ? 'job_listing' : defaultCategory === 'rfps' ? 'rfp_listing' : defaultCategory === 'talent' ? 'candidate' : 'agency';
      setListingType(listingTypeFromCategory);
    }
  }, [defaultCategory]);

  const handleKeywordChange = (e) => {
    const value = e.target.value;
    setKeyword(value);
  };

  const handleSelectChange = (value) => {
    
    const listingType1 = value === 'work' ? 'job_listing' : value === 'rfps' ? 'rfp_listing' : value === 'talent' ? 'candidate' : 'agency';
    setListingType(listingType1);
    
    const searchData= {
      keywords: keyword,
      pub_listingType: listingType1
    }

    if (onSubmit) {
      onSubmit(searchData);
    }

    // history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, {pub_listingType: `${listingType}`}));
  };

  const handleSearch = () => {
    // Submit the search with both keyword and listing type
    const searchData = {
      keywords: keyword,
      pub_listingType: listingType
    };
    
    if (onSubmit) {
      onSubmit(searchData);
    }
    
    // Blur input to hide software keyboard on mobile
    if (inputRef?.current) {
      inputRef.current.blur();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className={keywordSearchWrapperClasses}>
      <div
        className={css.headerSearch}
      >
        <Space.Compact className={css.headerSearchContainer}>
          <Select 
            id="searchSelect" 
            onChange={handleSelectChange} 
            placeholder="Select Category" 
            className={css.selectBox}
            style={{ minWidth: 140 }}
            value={defaultCategory}
            // allowClear
          >
            {currentUserType === 'customer' && (
              <>
                <Select.Option value="talent">Talent</Select.Option>
                <Select.Option value="partners">Suppliers</Select.Option>
                <Select.Option value="work">Work</Select.Option>
                <Select.Option value="rfps">RFPs</Select.Option>
              </>
            )}
            {currentUserType === 'candidate' && (
              <>
                <Select.Option value="work">Work</Select.Option>
                {/* Write for customer type user too */}
              </>
            )}
            {currentUserType === 'agency' && (
              <>
                <Select.Option value="talent">Talent</Select.Option>
                <Select.Option value="partners">Suppliers</Select.Option>
                {(!agencyType || agencyType === 'Staffing Services' || agencyType === 'Staffing and Implementation Services') && (!agencyType || teamRoleOf(currentUser) === 'Admin' || teamRoleOf(currentUser) === 'Staffing Sales') && (
                  <Select.Option value="work">Work</Select.Option>
                )}
                {(!agencyType || agencyType === 'Implementation Service' || agencyType === 'Staffing and Implementation Services') && (!agencyType || teamRoleOf(currentUser) === 'Admin' || teamRoleOf(currentUser) === 'Tech Sales') && (
                  <Select.Option value="rfps">RFPs</Select.Option>
                )}
              </>
            )}
            {!currentUser && (
              <>
                <Select.Option value="talent">Talent</Select.Option>
                <Select.Option value="partners">Suppliers</Select.Option>
                <Select.Option value="work">Work</Select.Option>
                <Select.Option value="rfps">RFPs</Select.Option>
              </>
            )}
          </Select>
          
          <Input 
            id="searchInput" 
            ref={inputRef}
            placeholder={listingType === 'candidate' ? 'Search talent...' : listingType === 'agency' ? 'Search suppliers...' : listingType === 'job_listing' ? 'Search work...' : listingType === 'rfp_listing' ? 'Search RFPs...' : defaultCategory === 'talent' ? 'Search talent...' : defaultCategory === 'partners' ? 'Search suppliers...' : defaultCategory === 'work' ? 'Search work...' : defaultCategory === 'rfps' ? 'Search RFPs...' : intl.formatMessage({
              id: 'TopbarSearchForm.placeholder',
            }) || "Search your next career path"} 
            value={keyword}
            onChange={handleKeywordChange}
            onPressEnter={handleKeyPress}
            style={{ flex: 1 }}
          />
          
          <Button 
            type="primary"
            size="large" 
            onClick={handleSearch}
            icon={<SearchOutlined />}
            disabled={!keyword.trim()}
          >
            {/* {!isMobile && 'Search'} */}
          </Button>
        </Space.Compact>
      </div>

      {/* Hidden field to maintain compatibility with react-final-form */}
      <Field
        name="keywords"
        render={({ input }) => {
          // Update the form field when keyword changes
          React.useEffect(() => {
            input.onChange(keyword);
          }, [keyword, input]);
          
          return <input type="hidden" {...input} />;
        }}
      />
      
      <Field
        name="listingType"
        render={({ input }) => {
          // Update the form field when listing type changes
          React.useEffect(() => {
            input.onChange(listingType);
          }, [listingType, input]);
          
          return <input type="hidden" {...input} />;
        }}
      />
    </div>
  );
};

const LocationSearchField = props => {
  const { desktopInputRootClass, intl, isMobile = false, inputRef, onLocationChange } = props;
  return (
    <Field
      name="location"
      format={identity}
      render={({ input, meta }) => {
        const { onChange, ...restInput } = input;

        // Merge the standard onChange function with custom behavior
        const searchOnChange = value => {
          onChange(value);
          onLocationChange(value);
        };

        return (
          <LocationAutocompleteInput
            className={isMobile ? css.mobileInputRoot : desktopInputRootClass}
            iconClassName={isMobile ? css.mobileIcon : css.desktopIcon}
            inputClassName={isMobile ? css.mobileInput : css.desktopInput}
            predictionsClassName={isMobile ? css.mobilePredictions : css.desktopPredictions}
            predictionsAttributionClassName={isMobile ? css.mobilePredictionsAttribution : null}
            placeholder={intl.formatMessage({ id: 'TopbarSearchForm.placeholder' })}
            closeOnBlur={!isMobile}
            inputRef={inputRef}
            input={{ ...restInput, onChange: searchOnChange }}
            meta={meta}
          />
        );
      }}
    />
  );
};

/**
 * The main search form for the Topbar with enhanced Ant Design UI.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {string?} props.desktopInputRoot root class for desktop form input
 * @param {Function} props.onSubmit
 * @param {boolean} props.isMobile
 * @param {Object} props.appConfig
 * @returns {JSX.Element} search form element
 */
const TopbarSearchForm = props => {
  const searchInputRef = useRef(null);
  const intl = useIntl();
  const { appConfig, onSubmit, pageLocation, ...restOfProps } = props;

  const onChange = location => {
    if (!isMainSearchTypeKeywords(appConfig) && location.selectedPlace) {
      // Auto-submit when a location is selected
      onSubmit({ location });
      // Blur search input to hide software keyboard
      searchInputRef?.current?.blur();
    }
  };

  const onKeywordSubmit = values => {
    if (isMainSearchTypeKeywords(appConfig)) {
      // Include both keywords and listingType in the submission
      const searchData = {
        keywords: values.keywords,
        ...(values.pub_listingType && { pub_listingType: values.pub_listingType })
      };
      onSubmit(searchData);
      // Blur search input to hide software keyboard
      searchInputRef?.current?.blur();
    }
  };

  const isKeywordsSearch = isMainSearchTypeKeywords(appConfig);
  const submit = isKeywordsSearch ? onKeywordSubmit : onSubmit;

  return (
    <FinalForm
      {...restOfProps}
      onSubmit={submit}
      render={formRenderProps => {
        const {
          rootClassName,
          className,
          desktopInputRoot,
          isMobile = false,
          handleSubmit,
          currentUser,
          profileListing,
        } = formRenderProps;
        const classes = classNames(rootClassName, className);
        const desktopInputRootClass = desktopInputRoot || css.desktopInputRoot;

        // Location search: allow form submit only when the place has changed
        const preventFormSubmit = e => e.preventDefault();
        const submitFormFn = isKeywordsSearch ? handleSubmit : preventFormSubmit;

        const keywordSearchWrapperClasses = classNames(
          css.keywordSearchWrapper,
          isMobile ? css.mobileInputRoot : desktopInputRootClass
        );

        return (
          <Form className={classes} onSubmit={submitFormFn} enforcePagePreloadFor="SearchPage">
            {isKeywordsSearch ? (
              <KeywordSearchField
                keywordSearchWrapperClasses={keywordSearchWrapperClasses}
                iconClass={classNames(isMobile ? css.mobileIcon : css.desktopIcon || css.icon)}
                intl={intl}
                isMobile={isMobile}
                inputRef={searchInputRef}
                onSubmit={onKeywordSubmit}
                currentUser={currentUser}
                profileListing={profileListing}
              />
            ) : (
              <LocationSearchField
                desktopInputRootClass={desktopInputRootClass}
                intl={intl}
                isMobile={isMobile}
                inputRef={searchInputRef}
                onLocationChange={onChange}
              />
            )}
          </Form>
        );
      }}
    />
  );
};

export default TopbarSearchForm;